<div class="retailer-lookup-container"
     (focusin)="onFocusIn()"
     (focusout)="onFocusOut()">
  <div class="retailer-lookup-display"
       fxLayout="row"
       fxLayoutAlign="space-between center"
       [class.disabled]="disabled">
    <span class="retailer-lookup-value body-3-default">
      {{ selectedRetailer()?.companyName ?? placeholder }}
    </span>
      <mat-icon matSuffix class="retailer-lookup-search-icon">search</mat-icon>
  </div>
</div>
